import { GET } from 'shared/utils/ajax';

const media = `/rest/media`;
const path = media + `/teacher`;

export const teacherAll$ = () => GET(`${path}/all/order`);
